{
  "tabs": {
    "info": "Info",
    "events": "Eventos",
    "schedule": "Horario",
    "matches": "Partidos",
    "players": "Jugadores",
    "stats": "Stats"
  },
  "players": {
    "name": "Nombre",
    "country": "País",
    "events": "Eventos",
    "rank": "Ranking",
    "noParticipants": "Sin participantes"
  },
  "schedule": {
    "court": "Cancha",
    "time": "Hora",
    "event": "Evento",
    "round": "Ronda",
    "matchUp": "Partido"
  },
  "display": {
    "label": "Visualización",
    "columns": "Columnas",
    "draw": "Cuadro",
    "tableView": "Vista de tabla",
    "statistics": "Estadísticas"
  },
  "theme": {
    "toggleDark": "Alternar modo oscuro"
  },
  "language": {
    "select": "Seleccionar idioma"
  }
}
